document.documentElement.classList.remove('no-js');

const money = (cents, currency = 'MAD') => new Intl.NumberFormat(document.documentElement.lang || 'fr-MA', { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100);

class VariantSelects extends HTMLElement {
  connectedCallback() { this.addEventListener('change', this.onVariantChange.bind(this)); }
  onVariantChange() {
    const options = [...this.querySelectorAll('fieldset')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
    const variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    const variant = variants.find((entry) => entry.options.every((value, index) => value === options[index]));
    if (!variant) return;

    const root = this.closest('[data-product-root]');
    const price = root?.querySelector('[data-product-price] .price__current');
    if (price) price.textContent = money(variant.price, window.Shopify.currency?.active || 'MAD');

    const codForms = root?.querySelectorAll('[id^="cod-"][data-cod-root]') || [];
    codForms.forEach((codForm) => {
      if (codForm.dataset) {
        codForm.dataset.variantId = variant.id;
        codForm.dataset.variant = variant.title || '';
        codForm.dataset.price = money(variant.price, window.Shopify.currency?.active || 'MAD');
      }
      if (typeof codForm.updateCodPrices === 'function') {
        codForm.updateCodPrices(variant.price);
      }
    });

    if (variant.featured_media) root?.querySelector(`[data-media-target="shopify-${variant.featured_media.id}"]`)?.click();
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
  }
}
customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const observer = new IntersectionObserver((entries, instance) => { if (!entries[0].isIntersecting) return; instance.disconnect(); fetch(this.dataset.url).then((response) => response.text()).then((text) => { const html = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations'); if (html?.innerHTML.trim()) this.innerHTML = html.innerHTML; }); }, { rootMargin: '0px 0px 400px 0px' });
    observer.observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const closeMenu = () => { menu?.classList.remove('is-open'); menu?.setAttribute('aria-hidden', 'true'); document.body.classList.remove('menu-open'); };
  document.querySelector('[data-menu-open]')?.addEventListener('click', () => { menu?.classList.add('is-open'); menu?.setAttribute('aria-hidden', 'false'); document.body.classList.add('menu-open'); });
  document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));
  menu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  document.querySelectorAll('[data-language-selector]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  document.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('[data-product-gallery]');
    gallery.querySelectorAll('[data-media-id]').forEach((media) => media.classList.toggle('is-hidden', media.dataset.mediaId !== button.dataset.mediaTarget));
    gallery.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }));

  document.querySelectorAll('[data-product-filters]').forEach((filters) => filters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-filter]'); if (!button) return;
    filters.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
    const grid = filters.parentElement.querySelector('[data-product-grid]');
    if (!grid) return;
    grid.querySelectorAll('[data-filter-key]').forEach((item) => {
      item.hidden = button.dataset.filter !== 'all' && item.dataset.filterKey !== button.dataset.filter;
    });
  }));

  document.querySelector('[data-sort-by]')?.addEventListener('change', (event) => { const url = new URL(window.location.href); url.searchParams.set('sort_by', event.target.value); window.location.assign(url.toString()); });

  document.querySelectorAll('[data-product-intro]').forEach((wrap) => {
    const body = wrap.querySelector('[data-product-intro-body]');
    const button = wrap.querySelector('[data-product-intro-toggle]');
    if (!body || !button) return;

    const needsClamp = body.scrollHeight > body.clientHeight + 2;
    if (!needsClamp) {
      wrap.classList.remove('is-clamped');
      return;
    }

    button.hidden = false;
    button.addEventListener('click', () => {
      const expanded = wrap.classList.toggle('is-expanded');
      wrap.classList.toggle('is-clamped', !expanded);
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? button.dataset.labelLess : button.dataset.labelMore;
    });
  });
});
